export const STATES_WITH_CITIES = {
  states: [
    {
      name: 'Alabama',
      abbreviation: 'AL',
      cities: [
        'Birmingham',
        'Montgomery',
        'Mobile',
        'Huntsville',
        'Tuscaloosa',
        'Hoover',
        'Dothan',
        'Auburn',
        'Decatur',
        'Madison',
      ],
    },
    {
      name: 'Alaska',
      abbreviation: 'AK',
      cities: [
        'Anchorage',
        'Fairbanks',
        'Juneau',
        'Sitka',
        'Ketchikan',
        'Wasilla',
        'Kenai',
        'Kodiak',
        'Bethel',
        'Palmer',
      ],
    },
    {
      name: 'Arizona',
      abbreviation: 'AZ',
      cities: [
        'Phoenix',
        'Tucson',
        'Mesa',
        'Chandler',
        'Glendale',
        'Scottsdale',
        'Gilbert',
        'Tempe',
        'Peoria',
        'Surprise',
      ],
    },
    {
      name: 'Arkansas',
      abbreviation: 'AR',
      cities: [
        'Little Rock',
        'Fort Smith',
        'Fayetteville',
        'Springdale',
        'Jonesboro',
        'North Little Rock',
        'Conway',
        'Rogers',
        'Bentonville',
        'Pine Bluff',
      ],
    },
    {
      name: 'California',
      abbreviation: 'CA',
      cities: [
        'Los Angeles',
        'San Diego',
        'San Jose',
        'San Francisco',
        'Fresno',
        'Sacramento',
        'Long Beach',
        'Oakland',
        'Bakersfield',
        'Anaheim',
      ],
    },
    {
      name: 'Colorado',
      abbreviation: 'CO',
      cities: [
        'Denver',
        'Colorado Springs',
        'Aurora',
        'Fort Collins',
        'Lakewood',
        'Thornton',
        'Arvada',
        'Westminster',
        'Pueblo',
        'Centennial',
      ],
    },
    {
      name: 'Connecticut',
      abbreviation: 'CT',
      cities: [
        'Bridgeport',
        'New Haven',
        'Stamford',
        'Hartford',
        'Waterbury',
        'Norwalk',
        'Danbury',
        'New Britain',
        'Meriden',
        'Bristol',
      ],
    },
    {
      name: 'Delaware',
      abbreviation: 'DE',
      cities: [
        'Wilmington',
        'Dover',
        'Newark',
        'Middletown',
        'Smyrna',
        'Milford',
        'Seaford',
        'Georgetown',
        'Elsmere',
        'New Castle',
      ],
    },
    {
      name: 'Florida',
      abbreviation: 'FL',
      cities: [
        'Jacksonville',
        'Miami',
        'Tampa',
        'Orlando',
        'St. Petersburg',
        'Hialeah',
        'Tallahassee',
        'Fort Lauderdale',
        'Port St. Lucie',
        'Cape Coral',
      ],
    },
    {
      name: 'Georgia',
      abbreviation: 'GA',
      cities: [
        'Atlanta',
        'Augusta',
        'Columbus',
        'Macon',
        'Savannah',
        'Athens',
        'Sandy Springs',
        'Roswell',
        'Johns Creek',
        'Albany',
      ],
    },
    {
      name: 'Hawaii',
      abbreviation: 'HI',
      cities: [
        'Honolulu',
        'Pearl City',
        'Hilo',
        'Kailua',
        'Waipahu',
        'Kaneohe',
        'Mililani',
        'Kahului',
        'Ewa Gentry',
        'Kihei',
      ],
    },
    {
      name: 'Idaho',
      abbreviation: 'ID',
      cities: [
        'Boise',
        'Meridian',
        'Nampa',
        'Idaho Falls',
        'Pocatello',
        'Caldwell',
        "Coeur d'Alene",
        'Twin Falls',
        'Lewiston',
        'Post Falls',
      ],
    },
    {
      name: 'Illinois',
      abbreviation: 'IL',
      cities: [
        'Chicago',
        'Aurora',
        'Rockford',
        'Joliet',
        'Naperville',
        'Springfield',
        'Peoria',
        'Elgin',
        'Waukegan',
        'Cicero',
      ],
    },
    {
      name: 'Indiana',
      abbreviation: 'IN',
      cities: [
        'Indianapolis',
        'Fort Wayne',
        'Evansville',
        'South Bend',
        'Carmel',
        'Fishers',
        'Bloomington',
        'Hammond',
        'Gary',
        'Lafayette',
      ],
    },
    {
      name: 'Iowa',
      abbreviation: 'IA',
      cities: [
        'Des Moines',
        'Cedar Rapids',
        'Davenport',
        'Sioux City',
        'Iowa City',
        'Waterloo',
        'Ames',
        'West Des Moines',
        'Council Bluffs',
        'Dubuque',
      ],
    },
    {
      name: 'Kansas',
      abbreviation: 'KS',
      cities: [
        'Wichita',
        'Overland Park',
        'Kansas City',
        'Olathe',
        'Topeka',
        'Lawrence',
        'Shawnee',
        'Manhattan',
        'Lenexa',
        'Salina',
      ],
    },
    {
      name: 'Kentucky',
      abbreviation: 'KY',
      cities: [
        'Louisville',
        'Lexington',
        'Bowling Green',
        'Owensboro',
        'Covington',
        'Hopkinsville',
        'Richmond',
        'Florence',
        'Georgetown',
        'Elizabethtown',
      ],
    },
    {
      name: 'Louisiana',
      abbreviation: 'LA',
      cities: [
        'New Orleans',
        'Baton Rouge',
        'Shreveport',
        'Lafayette',
        'Lake Charles',
        'Kenner',
        'Bossier City',
        'Monroe',
        'Alexandria',
        'Houma',
      ],
    },
    {
      name: 'Maine',
      abbreviation: 'ME',
      cities: [
        'Portland',
        'Lewiston',
        'Bangor',
        'South Portland',
        'Auburn',
        'Biddeford',
        'Sanford',
        'Augusta',
        'Saco',
        'Westbrook',
      ],
    },
    {
      name: 'Maryland',
      abbreviation: 'MD',
      cities: [
        'Baltimore',
        'Columbia',
        'Germantown',
        'Silver Spring',
        'Waldorf',
        'Glen Burnie',
        'Frederick',
        'Gaithersburg',
        'Rockville',
        'Bethesda',
      ],
    },
    {
      name: 'Massachusetts',
      abbreviation: 'MA',
      cities: [
        'Boston',
        'Worcester',
        'Springfield',
        'Lowell',
        'Cambridge',
        'New Bedford',
        'Brockton',
        'Quincy',
        'Lynn',
        'Fall River',
      ],
    },
    {
      name: 'Michigan',
      abbreviation: 'MI',
      cities: [
        'Detroit',
        'Grand Rapids',
        'Warren',
        'Sterling Heights',
        'Ann Arbor',
        'Lansing',
        'Flint',
        'Dearborn',
        'Livonia',
        'Westland',
      ],
    },
    {
      name: 'Minnesota',
      abbreviation: 'MN',
      cities: [
        'Minneapolis',
        'St. Paul',
        'Rochester',
        'Duluth',
        'Bloomington',
        'Brooklyn Park',
        'Plymouth',
        'Maple Grove',
        'Woodbury',
        'St. Cloud',
      ],
    },
    {
      name: 'Mississippi',
      abbreviation: 'MS',
      cities: [
        'Jackson',
        'Gulfport',
        'Southaven',
        'Hattiesburg',
        'Biloxi',
        'Meridian',
        'Tupelo',
        'Greenville',
        'Olive Branch',
        'Horn Lake',
      ],
    },
    {
      name: 'Missouri',
      abbreviation: 'MO',
      cities: [
        'Kansas City',
        'St. Louis',
        'Springfield',
        'Independence',
        'Columbia',
        "Lee's Summit",
        "O'Fallon",
        'St. Joseph',
        'St. Charles',
        'St. Peters',
      ],
    },
    {
      name: 'Montana',
      abbreviation: 'MT',
      cities: [
        'Billings',
        'Missoula',
        'Great Falls',
        'Bozeman',
        'Butte',
        'Helena',
        'Kalispell',
        'Havre',
        'Anaconda',
        'Miles City',
      ],
    },
    {
      name: 'Nebraska',
      abbreviation: 'NE',
      cities: [
        'Omaha',
        'Lincoln',
        'Bellevue',
        'Grand Island',
        'Kearney',
        'Fremont',
        'Hastings',
        'Norfolk',
        'North Platte',
        'Columbus',
      ],
    },
    {
      name: 'Nevada',
      abbreviation: 'NV',
      cities: [
        'Las Vegas',
        'Henderson',
        'Reno',
        'North Las Vegas',
        'Sparks',
        'Carson City',
        'Fernley',
        'Elko',
        'Mesquite',
        'Boulder City',
      ],
    },
    {
      name: 'New Hampshire',
      abbreviation: 'NH',
      cities: [
        'Manchester',
        'Nashua',
        'Concord',
        'Derry',
        'Dover',
        'Rochester',
        'Salem',
        'Merrimack',
        'Hudson',
        'Londonderry',
      ],
    },
    {
      name: 'New Jersey',
      abbreviation: 'NJ',
      cities: [
        'Newark',
        'Jersey City',
        'Paterson',
        'Elizabeth',
        'Edison',
        'Woodbridge',
        'Lakewood',
        'Toms River',
        'Hamilton',
        'Trenton',
      ],
    },
    {
      name: 'New Mexico',
      abbreviation: 'NM',
      cities: [
        'Albuquerque',
        'Las Cruces',
        'Rio Rancho',
        'Santa Fe',
        'Roswell',
        'Farmington',
        'Clovis',
        'Hobbs',
        'Alamogordo',
        'Carlsbad',
      ],
    },
    {
      name: 'New York',
      abbreviation: 'NY',
      cities: [
        'New York City',
        'Buffalo',
        'Rochester',
        'Yonkers',
        'Syracuse',
        'Albany',
        'New Rochelle',
        'Mount Vernon',
        'Schenectady',
        'Utica',
      ],
    },
    {
      name: 'North Carolina',
      abbreviation: 'NC',
      cities: [
        'Charlotte',
        'Raleigh',
        'Greensboro',
        'Durham',
        'Winston-Salem',
        'Fayetteville',
        'Cary',
        'Wilmington',
        'High Point',
        'Greenville',
      ],
    },
    {
      name: 'North Dakota',
      abbreviation: 'ND',
      cities: [
        'Fargo',
        'Bismarck',
        'Grand Forks',
        'Minot',
        'West Fargo',
        'Mandan',
        'Dickinson',
        'Jamestown',
        'Williston',
        'Wahpeton',
      ],
    },
    {
      name: 'Ohio',
      abbreviation: 'OH',
      cities: [
        'Columbus',
        'Cleveland',
        'Cincinnati',
        'Toledo',
        'Akron',
        'Dayton',
        'Parma',
        'Canton',
        'Youngstown',
        'Lorain',
      ],
    },
    {
      name: 'Oklahoma',
      abbreviation: 'OK',
      cities: [
        'Oklahoma City',
        'Tulsa',
        'Norman',
        'Broken Arrow',
        'Lawton',
        'Edmond',
        'Moore',
        'Midwest City',
        'Stillwater',
        'Enid',
      ],
    },
    {
      name: 'Oregon',
      abbreviation: 'OR',
      cities: [
        'Portland',
        'Salem',
        'Eugene',
        'Gresham',
        'Hillsboro',
        'Beaverton',
        'Bend',
        'Medford',
        'Springfield',
        'Corvallis',
      ],
    },
    {
      name: 'Pennsylvania',
      abbreviation: 'PA',
      cities: [
        'Philadelphia',
        'Pittsburgh',
        'Allentown',
        'Erie',
        'Reading',
        'Scranton',
        'Bethlehem',
        'Lancaster',
        'Harrisburg',
        'Altoona',
      ],
    },
    {
      name: 'Rhode Island',
      abbreviation: 'RI',
      cities: [
        'Providence',
        'Warwick',
        'Cranston',
        'Pawtucket',
        'East Providence',
        'Woonsocket',
        'Coventry',
        'Cumberland',
        'North Providence',
        'South Kingstown',
      ],
    },
    {
      name: 'South Carolina',
      abbreviation: 'SC',
      cities: [
        'Columbia',
        'Charleston',
        'North Charleston',
        'Mount Pleasant',
        'Rock Hill',
        'Greenville',
        'Summerville',
        'Sumter',
        'Hilton Head Island',
        'Spartanburg',
      ],
    },
    {
      name: 'South Dakota',
      abbreviation: 'SD',
      cities: [
        'Sioux Falls',
        'Rapid City',
        'Aberdeen',
        'Brookings',
        'Watertown',
        'Mitchell',
        'Yankton',
        'Pierre',
        'Huron',
        'Vermillion',
      ],
    },
    {
      name: 'Tennessee',
      abbreviation: 'TN',
      cities: [
        'Nashville',
        'Memphis',
        'Knoxville',
        'Chattanooga',
        'Clarksville',
        'Murfreesboro',
        'Franklin',
        'Jackson',
        'Johnson City',
        'Bartlett',
      ],
    },
    {
      name: 'Texas',
      abbreviation: 'TX',
      cities: [
        'Houston',
        'San Antonio',
        'Dallas',
        'Austin',
        'Fort Worth',
        'El Paso',
        'Arlington',
        'Corpus Christi',
        'Plano',
        'Laredo',
      ],
    },
    {
      name: 'Utah',
      abbreviation: 'UT',
      cities: [
        'Salt Lake City',
        'West Valley City',
        'Provo',
        'West Jordan',
        'Orem',
        'Sandy',
        'Ogden',
        'St. George',
        'Layton',
        'Taylorsville',
      ],
    },
    {
      name: 'Vermont',
      abbreviation: 'VT',
      cities: [
        'Burlington',
        'Essex',
        'South Burlington',
        'Colchester',
        'Rutland',
        'Bennington',
        'Brattleboro',
        'Milton',
        'Hartford',
        'Barre',
      ],
    },
    {
      name: 'Virginia',
      abbreviation: 'VA',
      cities: [
        'Virginia Beach',
        'Norfolk',
        'Chesapeake',
        'Richmond',
        'Newport News',
        'Alexandria',
        'Hampton',
        'Roanoke',
        'Portsmouth',
        'Suffolk',
      ],
    },
    {
      name: 'Washington',
      abbreviation: 'WA',
      cities: [
        'Seattle',
        'Spokane',
        'Tacoma',
        'Vancouver',
        'Bellevue',
        'Kent',
        'Everett',
        'Renton',
        'Yakima',
        'Spokane Valley',
      ],
    },
    {
      name: 'West Virginia',
      abbreviation: 'WV',
      cities: [
        'Charleston',
        'Huntington',
        'Morgantown',
        'Parkersburg',
        'Wheeling',
        'Weirton',
        'Fairmont',
        'Martinsburg',
        'Beckley',
        'Clarksburg',
      ],
    },
    {
      name: 'Wisconsin',
      abbreviation: 'WI',
      cities: [
        'Milwaukee',
        'Madison',
        'Green Bay',
        'Kenosha',
        'Racine',
        'Appleton',
        'Waukesha',
        'Oshkosh',
        'Eau Claire',
        'Janesville',
      ],
    },
    {
      name: 'Wyoming',
      abbreviation: 'WY',
      cities: [
        'Cheyenne',
        'Casper',
        'Laramie',
        'Gillette',
        'Rock Springs',
        'Sheridan',
        'Green River',
        'Evanston',
        'Riverton',
        'Cody',
      ],
    },
  ],
}

export function slugify(str: string) {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

// Output a source and and destination object like the following
// example for each state in STATES_WITH_CITIES, and for each city
// in the state's cities array:
// state example:
//  {
//     "source": "/jobs/state/vermont",
//     "destination": "/jobs?matchLocation=country%3Dunited_states%26state%3DVT"
//   },
// city example:
//   {
//     "source": "/jobs/state/vermont/city/burlington",
//     "destination": "/jobs?matchLocation=state%3DVT%26city%3DBurlington%26country%3Dunited_states"
//   },

const STATES_REDIRECTS = STATES_WITH_CITIES.states.map((state) => {
  const stateSource = `/jobs/state/${slugify(state.name.toLowerCase())}`
  const stateDestination = `/jobs?matchLocation=country%3Dunited_states%26state%3D${state.abbreviation}`

  return {
    source: stateSource,
    destination: stateDestination,
  }
})

const STATES_CAPITALIZED_REDIRECTS = STATES_WITH_CITIES.states.map((state) => {
  const stateSource = `/jobs/state/${slugify(state.name)}`
  const stateDestination = `/jobs?matchLocation=country%3Dunited_states%26state%3D${state.abbreviation}`

  return {
    source: stateSource,
    destination: stateDestination,
  }
})

const STATES_ABBREVIATION_REDIRECTS = STATES_WITH_CITIES.states.map((state) => {
  const stateSource = `/jobs/state/${slugify(state.abbreviation)}`
  const stateDestination = `/jobs?matchLocation=country%3Dunited_states%26state%3D${state.abbreviation}`

  return {
    source: stateSource,
    destination: stateDestination,
  }
})

const STATES_LOWER_ABBREVIATION_REDIRECTS = STATES_WITH_CITIES.states.map(
  (state) => {
    const stateSource = `/jobs/state/${slugify(
      state.abbreviation.toLowerCase(),
    )}`
    const stateDestination = `/jobs?matchLocation=country%3Dunited_states%26state%3D${state.abbreviation}`

    return {
      source: stateSource,
      destination: stateDestination,
    }
  },
)

const CITIES_REDIRECTS = STATES_WITH_CITIES.states
  .map((state) => {
    const cities = state.cities.map((city) => {
      const citySource = `/jobs/state/${slugify(
        state.name.toLowerCase(),
      )}/city/${slugify(city.toLowerCase())}`
      const cityDestination = `/jobs?matchLocation=state%3D${
        state.abbreviation
      }%26city%3D${slugify(city.toLowerCase())}%26country%3Dunited_states`

      return {
        source: citySource,
        destination: cityDestination,
      }
    })
    return cities
  })
  .flat()

const CITIES__WITH_LOWER_STATE_ABBREVIATION_REDIRECTS =
  STATES_WITH_CITIES.states
    .map((state) => {
      const cities = state.cities.map((city) => {
        const citySource = `/jobs/state/${state.abbreviation.toLowerCase()}/city/${slugify(
          city.toLowerCase(),
        )}`
        const cityDestination = `/jobs?matchLocation=state%3D${
          state.abbreviation
        }%26city%3D${slugify(city.toLowerCase())}%26country%3Dunited_states`

        return {
          source: citySource,
          destination: cityDestination,
        }
      })
      return cities
    })
    .flat()

const CITIES_WITH_STATE_ABBREVIATION_REDIRECTS = STATES_WITH_CITIES.states
  .map((state) => {
    const cities = state.cities.map((city) => {
      const citySource = `/jobs/state/${state.abbreviation}/city/${slugify(
        city.toLowerCase(),
      )}`
      const cityDestination = `/jobs?matchLocation=state%3D${
        state.abbreviation
      }%26city%3D${slugify(city.toLowerCase())}%26country%3Dunited_states`

      return {
        source: citySource,
        destination: cityDestination,
      }
    })
    return cities
  })
  .flat()

export const STATES_AND_CITIES_REDIRECTS = STATES_REDIRECTS.concat(
  STATES_CAPITALIZED_REDIRECTS,
)
  .concat(STATES_ABBREVIATION_REDIRECTS)
  .concat(STATES_LOWER_ABBREVIATION_REDIRECTS)
  .concat(CITIES_REDIRECTS)
  .concat(CITIES__WITH_LOWER_STATE_ABBREVIATION_REDIRECTS)
  .concat(CITIES_WITH_STATE_ABBREVIATION_REDIRECTS)
